import graphqlClient from "../../../apollo";

class ZoneProvider {

    fetchZonesPoint({latitude, longitude}) {
        return graphqlClient.query({
            query: require('./gql/Zone/zonesPoint.graphql'),
            variables: {latitude, longitude},
            fetchPolicy: "network-only"
        })
    }

    fetchZonePoint({latitude, longitude}) {
        return graphqlClient.query({
            query: require('./gql/Zone/zonePoint.graphql'),
            variables: {latitude, longitude},
            fetchPolicy: "network-only"
        })
    }

    findZone(id) {
        return graphqlClient.query({
            query: require('./gql/Zone/findZone.graphql'),
            variables: {id:id},
            fetchPolicy: "network-only"
        })
    }

    fetchZone() {
        return graphqlClient.query({
            query: require('./gql/Zone/fetchZone.graphql'),
            fetchPolicy: "network-only"
        })
    }

    paginateZone(pageNumber, itemsPerPage, search = null, filters = null,  orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/Zone/paginateZone.graphql'),
            variables: {pageNumber, itemsPerPage, search, filters, orderBy, orderDesc},
            fetchPolicy: "network-only"
        })
    }



    createZone(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Zone/createZone.graphql'),
            variables: {input}
        })
    }

    updateZone(id,input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Zone/updateZone.graphql'),
            variables: {id, input}
        })
    }

     deleteZone(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/Zone/deleteZone.graphql'),
            variables: {id}
        })
    }

}

export default new ZoneProvider()


